const CTA_HOST_SELECTOR = '[data-storeeel-cta-host]';

export const getCtaHosts = (root = document) => {
  if (!root?.querySelectorAll) return [];
  return Array.from(root.querySelectorAll(CTA_HOST_SELECTOR));
};

export const queryCtaElements = (selector, root = document) => {
  const hosts = getCtaHosts(root);
  if (hosts.length === 0) {
    return root?.querySelectorAll ? Array.from(root.querySelectorAll(selector)) : [];
  }
  const elements = [];
  hosts.forEach((host) => {
    if (host.shadowRoot) {
      elements.push(...host.shadowRoot.querySelectorAll(selector));
    }
  });
  return elements;
};

export const queryCtaElement = (selector, root = document) => {
  const host = getCtaHosts(root)[0];
  if (host?.shadowRoot) {
    return host.shadowRoot.querySelector(selector);
  }
  return root?.querySelector ? root.querySelector(selector) : null;
};

export const queryCtaElementsInElement = (selector, element) => {
  if (!element?.querySelector) return [];
  const host = element.querySelector(CTA_HOST_SELECTOR);
  if (host?.shadowRoot) {
    return Array.from(host.shadowRoot.querySelectorAll(selector));
  }
  return Array.from(element.querySelectorAll(selector));
};

export const isCtaHostTarget = (target) => {
  if (!target || typeof target.closest !== 'function') return false;
  return Boolean(target.closest(CTA_HOST_SELECTOR));
};
